import {
  CustomLink,
  Flex,
  Heading,
  IconButton,
  TertiaryButton,
} from '@moonpig/launchpad-components'
import { spacingPx } from '@moonpig/launchpad-theme'
import { system as s } from '@moonpig/launchpad-system'
import { css, styled } from '@moonpig/launchpad-utils'
import { IconSystemBasket } from '@moonpig/launchpad-assets'

const iconActionStyles = css`
  ${s({
    width: 'touchSquare',
    height: 'touchSquare',
  })}

  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`

const focusIndicatorStyles = css`
  transition: box-shadow 150ms linear;

  @media (prefers-reduced-motion) {
    transition: none;
  }

  &:not(:disabled) {
    &:focus {
      outline: transparent;

      ${s({
        boxShadow: 5,
      })}
    }

    &:focus:not(:focus-visible) {
      ${s({
        boxShadow: 0,
      })}
    }
  }
`

export const StyledFlex = styled(Flex)`
  ${s({
    bgcolor: 'colorBackground01',
    gap: 2,
    py: 3,
    px: 5,
    zIndex: 'zIndexDropdown',
  })}
  height: 76px;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  backdrop-filter: blur(10px);
  position: relative;
`

export const StyledIconSystemBasket = styled(IconSystemBasket)`
  width: ${spacingPx(9)};
  height: ${spacingPx(9)};
  display: block;
  flex-shrink: 0;
  color: currentcolor;
`

export const StyledBasketIconLink = styled(CustomLink)`
  ${iconActionStyles}
  ${focusIndicatorStyles}

  ${s({
    color: 'colorInteractionIcon',
    borderRadius: 2,
  })}

  position: relative;
  text-decoration: none;

  &:hover {
    ${s({
      color: 'colorInteractionIconHover',
    })}
    text-decoration: none;
  }

  &:focus {
    ${s({
      color: 'colorInteractionSelectedState',
    })}

    &:hover {
      ${s({
        color: 'colorInteractionIconHover',
      })}
    }
  }

  &:active {
    ${s({
      color: 'colorInteractionSelectedState',
    })}
  }
`

export const StyledBasketCountBadge = styled.span`
  ${s({
    bgcolor: 'colorInteractionDefault',
    typography: {
      xs: 'typeMobileDisplay06',
      md: 'typeDesktopBodyCaption',
    },
    color: 'white',
    borderRadius: 7,
  })}

  position: absolute;
  top: 0;
  left: 50%;
  min-width: 20px;
  height: 20px;
  line-height: 20px;
  padding: 0 4px;
  text-align: center;
`

export const StyledCloseButton = styled(IconButton)`
  ${iconActionStyles}
`

export const StyledHeading = styled(Heading)`
  ${s({
    typography: 'typeDesktopDisplay05',
    color: 'colorTextHeadline',
    fontWeight: '700',
    lineHeight: '1.2',
    marginBottom: '0px',
    marginRight: 'auto',
  })}
 `

export const StyledOptionsMenuWrapper = styled.div`
  > button {
    ${s({
      bgcolor: 'colorBackground01',
      border: 1,
      borderColor: 'colorBorder03',
      borderRadius: 'borderRadiusCircle',
      boxShadow: 'boxShadow02',
      color: 'colorTextHeadline',
    })}
    ${iconActionStyles}
    padding: 0;
  }

  > button:hover {
    ${s({
      bgcolor: 'colorBackground02',
    })}
  }

  [role='menu'] {
    width: fit-content;
    ${s({
      bgcolor: 'colorBackground01',
      p: 0,
      pt: 4,
      pb: 4,
      border: 1,
      borderColor: 'colorBorder03',
      borderRadius: 'borderRadius02',
      boxShadow: 'boxShadow02',
    })}
    overflow: visible;
    box-sizing: border-box;
  }

  [role='menu'] li {
    display: block;
  }
`

export const StyledMenuAction = styled(TertiaryButton)`
  ${s({
    p: 2,
    px: 8,
    borderRadius: 'borderRadius01',
    typography: 'typeBodyLabel',
    color: 'colorTextHeadline',
  })}

  width: fit-content;
  justify-content: center;
  text-align: center;
  text-decoration: none;
  white-space: nowrap;

  &:not(:disabled):hover {
    ${s({
      bgcolor: 'colorBackground02',
      color: 'colorTextHeadline',
    })}
  }

  &:not(:disabled):focus,
  &:not(:disabled):active {
    ${s({ color: 'colorTextHeadline' })}
  }

  &:disabled {
    opacity: 0.45;
  }
`
